const Select = ({
  form,
  errors,
  title,
  icon,
  placeholder,
  id,
  options,
  disabled,
}: any) => {
  return (
    <div className={`${disabled ? "disable-input" : ""}`}>
      <div className="label">
        <span className="label-text">{title}</span>
      </div>
      <label className="input pl-2 flex items-center gap-2 bg-white border-[1px] border-gray-300">
        {icon}

        <select
          disabled={disabled}
          placeholder={placeholder}
          className={`h-full w-full bg-transparent focus:outline-none`}
          {...form.register(id)}
        >
          <option></option>
          {options.map((opt: any) => (
            <option value={opt.value} key={opt.id}>
              {opt.label}
            </option>
          ))}
        </select>
      </label>

      <div className="label">
        <span className="label-text-alt">
          {errors[id] && (
            <span style={{ color: "red" }}>{errors[id].message}</span>
          )}
        </span>
      </div>
    </div>
  );
};

export default Select;
